// Vite process.env compatibility shim - must be first
import "./process-shim";
// Safari < 17.4: pdfjs-dist 5.x requires Promise.withResolvers — before react-pdf
import "./utils/promiseWithResolversPolyfill";

import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/antd.min.css";
import "./index.scss";
// import reportWebVitals from './reportWebVitals';
import App from "./App";
import { isHomeEDApp, isUrlShortenApp } from "@constants";
import { PresentationProvider } from "./hooks/usePresentationContext";
import SentrySingleton from "./services/SentrySingleton";

import { configurePdfJsWorker } from "./utils/configurePdfJsWorker";
import { logger } from "./utils/logger";
import { initializePrivacyProtection } from "./utils/privacy";
import "./utils/urlParse";

// Import Sentry test functions (only in development)
if (import.meta.env.DEV) {
  import("./utils/testSentryIntegration");
}

configurePdfJsWorker();

// Initialize Sentry with optimized configuration
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
// Use VITE_SENTRY_ENVIRONMENT for Sentry environment configuration

if (SENTRY_DSN) {
  // Initialize Sentry using singleton pattern
  const sentrySingleton = SentrySingleton.getInstance();
  sentrySingleton.initialize().catch((error) => {
    logger.error("Failed to initialize Sentry singleton:", error);
  });
} else {
  logger.info("Sentry DSN not provided, skipping Sentry initialization");
}

// Initialize privacy protection for session replay
initializePrivacyProtection();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

if (isUrlShortenApp) {
  const ShortenApp = React.lazy(() => import("./ShortenApp"));

  root.render(
    <React.StrictMode>
      <PresentationProvider>
        <ShortenApp />
      </PresentationProvider>
    </React.StrictMode>,
  );
} else {
  const AppRender = !isHomeEDApp
    ? App
    : React.lazy(() => import("./HomeEdApp"));

  root.render(
    <React.StrictMode>
      <PresentationProvider>
        <AppRender />
      </PresentationProvider>
    </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
